import { v4 } from 'uuid';
import { IOrderItem } from '../../../../cart/domain/models/IOrderItem';
import {
  ConsumeOrderRequest,
  ConsumptionItemAdditionalRequest,
  ConsumptionItemObservationRequest,
  ConsumptionItemRequest,
  OrderRequest,
} from '../../../domain/dtos/ConsumeOrderRequest';
import { ProductType } from '../../../../catalog/domain/models/ProductType';

const ParseCartOrderItemsToConsumeOrderRequest = (
  localId: string,
  orderItems: IOrderItem[],
  accountId: string,
  orderPadId: string,
  equipamentId: string,
  orderNumber: string,
  orderId: string,
  operatorId?: string,
) => {
  const orderItemConsume: ConsumptionItemRequest[] = orderItems.flatMap(orderItem => {
    const consumptionItemAdditionalRequest: ConsumptionItemAdditionalRequest[] =
      orderItem.orderComposition?.flatMap(item => item.compositionItems)
        .filter(item => !!item.productId)
        .map(compositionItem => ({
          selectedQuantity: compositionItem.quantity,
          productId: compositionItem.productId ?? '',
          unitValue: compositionItem.price,
          complementGroupId: compositionItem.compositionId
        })) ?? [];

    let consumptionItemObservationRequest: ConsumptionItemObservationRequest[] = [];
    orderItem.orderComposition?.forEach(itemComposition => {
      itemComposition.compositionItems.forEach(option => {
        if (!option.productId && option.quantity > 0) {
          consumptionItemObservationRequest.push({
            id: option.id, // uuid
            question: itemComposition.description,
            answer: option.description,
          });
        }
      });
    });

    const ticketsIds = orderItem.ticketIds ?? Array.from(Array(orderItem.productType === ProductType.Kilo ? 1 : orderItem.quantity).keys()).map(() => v4());

    if (consumptionItemAdditionalRequest.length > 0 && orderItem.quantity > 1) {
      return Array.from({ length: orderItem.quantity }, (_, index) => ({
        productId: orderItem.productId,
        unitValue: orderItem.totalPrice,
        discountValue: 0,
        productName: orderItem.name,
        quantity: 1,
        additionals: consumptionItemAdditionalRequest,
        observations: consumptionItemObservationRequest,
        annotation: orderItem.notes,
        ticketsIds: [ticketsIds[index]],
      }));
    }

    return {
      // destinyId: orderPadId,
      productId: orderItem.productId, //uuid
      unitValue: orderItem.totalPrice,
      discountValue: 0,
      productName: orderItem.name,
      quantity: orderItem.quantity,
      additionals: consumptionItemAdditionalRequest,
      observations: consumptionItemObservationRequest,
      annotation: orderItem.notes,
      ticketsIds: ticketsIds, //uuid
    };
  });

  const newOrderConsume: OrderRequest = {
    orderId, //uuid
    destinyId: orderPadId, //uuid
    orderNumber: orderNumber,
    createdAt: new Date().toISOString(),
    operatorId,
    items: orderItemConsume,
  };

  const requestConsume: ConsumeOrderRequest = {
    localId,
    accountId, //uuid
    equipamentId, //uuid
    order: newOrderConsume,
    operatorId
  };

  return requestConsume;
};
export default ParseCartOrderItemsToConsumeOrderRequest;
